import React, { useState, useEffect } from "react";

import SuperBanner from "../components/SuperBanner";

const ONLINE_ORDER_URL = "https://bagels-round-top.clusterpos.com";

const Home = () => {
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      const hasSeenPrompt = localStorage.getItem("pwa-prompt-dismissed");
      if (!hasSeenPrompt) {
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("PWA installed");
    }

    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismissInstall = () => {
    setShowInstallPrompt(false);
    localStorage.setItem("pwa-prompt-dismissed", "true");
  };

  const handleOrderClick = () => {
    window.location.href = ONLINE_ORDER_URL;
  };

  return (
    <div className="relative min-h-screen flex flex-col overflow-hidden">
        {/* Background Image with Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-70"
          style={{
            backgroundImage: "url('/bagels_bg_img.jpg')",
          }}
        />
        <div className="absolute inset-0" />

        {/* Super Bagel protein banner */}
        <SuperBanner />

        {/* Divider bar between banner and content */}
        <div className="relative z-10 h-2 bg-[#c8543b] shadow-[0_4px_10px_-2px_rgba(0,0,0,0.35)]" />

        {/* Content */}
        <div className="relative z-10 flex-1 min-h-[calc(100vh-200px)] flex flex-col items-center justify-center gap-8 max-w-2xl w-full mx-auto px-10 py-5">
          {/* Logo */}
          <div className="flex justify-center">
            <img
              src="/logo_brt_couleur.png"
              alt="Bagels Round Top"
              className="rounded-sm max-h-[300px] sm:max-h-[280px]"
              style={{
                filter: "drop-shadow(0 0 10px rgba(255, 255, 255, 0.9))",
              }}
            />
          </div>

          {/* Order Button */}
          <button
            onClick={handleOrderClick}
            className="bg-[#df5742] hover:bg-[#c54937] text-white font-bold py-4 px-8 sm:px-12 rounded-lg text-lg sm:text-xl transition-all duration-200 transform hover:scale-105 shadow-lg w-full sm:w-auto"
          >
            Passez vos commandes en ligne
          </button>
        </div>

        {/* PWA Install Prompt */}
        {showInstallPrompt && (
          <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t-2 border-[#df5742] p-4 sm:p-6 z-50 animate-slide-up">
            <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <img
                  src="/icon.png"
                  alt="Bagels Round Top"
                  className="w-12 h-12 rounded-lg"
                />
                <div>
                  <h3 className="font-bold text-gray-800">
                    Installer l'application
                  </h3>
                  <p className="text-sm text-gray-600">
                    Ajoutez Bagels Round Top à votre écran d'accueil
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={handleDismissInstall}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 font-semibold"
                >
                  Plus tard
                </button>
                <button
                  onClick={handleInstallClick}
                  className="bg-[#df5742] hover:bg-[#c54937] text-white font-bold py-2 px-6 rounded-lg transition-all duration-200"
                >
                  Installer
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default Home;
